<template>
  <div class="ui-city-suggest">
    <ui-input
      ref="query"
      v-model="query"
      :label="label"
      autocomplete="off"
      placeholder="Начните вводить город"
      :validate="validate"
      clearable
      :disabled="disabled"
      @update:model-value="getSuggestions"
      @focus="getSuggestions"
      @blur="autofill"
    />
    <div class="ui-city-suggestions">
      <ui-dropdown
        :visible="showSuggestions"
      >
        <template v-if="suggestions.length">
          <div
            v-for="city in suggestions"
            :key="city.id"
            @mousedown="select(city)"
          >
            {{ city.name }}
          </div>
        </template>
        <template v-else>
          <div class="not-found">
            По вашему запросу ничего не найдено
          </div>
        </template>
      </ui-dropdown>
    </div>
  </div>
</template>

<script>
import { debounce } from 'throttle-debounce';

export default {
  name: 'ui-city-suggest',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Object,
      default: () => ({}), // { id, name }
    },
    label: {
      type: String,
      default: 'Город',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isMounted: false,
    query: '',
    currentCity: {},
    suggestions: [],
  }),

  computed: {
    showSuggestions() {
      return this.isMounted && this.$refs.query.focused && this.query.length > 1;
    },
    validate() {
      return this.required ? 'required' : [];
    },
  },

  watch: {
    current(city) {
      this.currentCity = city;
    },
  },
  created() {
    this.currentCity = this.current;
    this.query = this.currentCity.name || '';
    if (!(typeof window === 'undefined') && !this.currentCity.name && this.currentCity.id) {
      // передали только id города
      this.$store.$api.getCities([this.currentCity.id]).then(([city]) => {
        this.currentCity = {
          id: city?.id || '',
          name: city?.name || '',
        };
        this.query = this.currentCity.name;
      }).catch(() => {});
    }
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    select(city = {}) {
      if (city.id && city.name) {
        this.query = city.name || this.query;
        this.$emit('change', city);
      }
    },
    autofill() {
      // кейс, когда мы впечатали город полностью, но не выбрали в селекте
      const foundCity = this.suggestions.find((city) => city.name.toLowerCase() === this.query.toLowerCase());

      if (foundCity) {
        this.select(foundCity);
      } else {
        this.select(this.currentCity);
      }
    },
    getSuggestions: debounce(300, false, function (query = this.query) {
      if (query.length < 2) return;
      this.$store.$api.findCity({ query }).then((cities) => {
        this.suggestions = cities.map(({ id, name }) => ({ id, name }));
      }).catch(() => {
        this.$logger.warn(`По запросу "${this.query}" ничего не найдено`);
      });
    }),
    checkValidOutside() {
      return this.$refs?.query?.checkValidOutside();
    },
  },
};
</script>

<style lang="scss">
.ui-city-suggest {
  position: relative;
}

.ui-city-suggestions {
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  .ui-dropdown {
    margin-top: 8px;
    width: 100%;
  }
  .ui-dropdown-scrollview {
    max-height: 216px;
    & > div {
      margin-top: 0;
      padding: 8px 12px;
      line-height: 24px;
    }

    & > div:hover {
      background-color: $gray_bgr;
    }
  }

  .not-found {
    font-size: 14px;
    line-height: 20px;
    color: $gray;
  }
}
</style>
